import fetch from "cross-fetch";

import { encodeSearchParams } from "./search-params";
import {
    ITrelloClient,
    GetMemberOptions,
    TrelloMember
} from "./trello-client.types";

export type TrelloClientOptions = {
    readonly baseUrl?: string;
};

export class TrelloClient implements ITrelloClient {
    private readonly baseUrl: string;

    public constructor({ baseUrl = "" }: TrelloClientOptions = {}) {
        this.baseUrl = baseUrl;
    }

    /**
     * @see https://developer.atlassian.com/cloud/trello/rest/#api-members-id-get
     */
    public async getMember({
        id = "me",
        organizations,
        organizationFields,
        credits
    }: GetMemberOptions = {}): Promise<TrelloMember> {
        const searchParams = encodeSearchParams({
            organizations,
            organization_fields: organizationFields,
            credits
        });
        const response = await fetch(
            `${this.baseUrl}/1/members/${id}${
                searchParams ? `?${searchParams}` : ""
            }`,
            {
                credentials: "include"
            }
        );

        if (response.ok) {
            return await response.json();
        } else {
            throw Error(await response.text());
        }
    }
}
